import { Component, OnInit, Renderer2 } from '@angular/core';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { TableData } from 'src/app/shared/models/tableData';
import { JobPointeSettingsService } from 'src/app/service/job-pointe-settings/job-pointe-settings.service';
import { BehaviorSubject } from 'rxjs';
@Component({
  selector: 'app-manage-jobs-list',
  templateUrl: './manage-jobs-list.component.html',
  styleUrls: ['./manage-jobs-list.component.scss'],
})
export class ManageJobsListComponent implements OnInit {
  constructor(
    private jobPointeSettingsService: JobPointeSettingsService,
    public renderer2: Renderer2,
    private loaderService: LoaderService,
  ) {}

  ngOnInit(): void {}

  private modalIsOpenSource = new BehaviorSubject<boolean>(false);
  modalIsOpen = this.modalIsOpenSource.asObservable();

  modelDetail: any = {
    'asset-classes': {},
    categories: {},
    manufacturers: {},
    enabled: {},
  };

  data: TableData = {
    label: 'Manage Employee',
    type: 'manageJobs',
    editAccess: true,
    selectable: false,
    statusToggle: false,
    columns: [
      {
        name: 'name',
        label: 'Job Name',
        property: row => `${row?.firstName} ${row?.lastName}`,
        sortable: true,
        columnStyles: { 'max-width': '200px' },
        headerStyles: { 'min-width': '6rem' },
        columnClasses: { 'text-truncate': false },
      },
      {
        name: 'unionLocal',
        label: 'Foreman',
        property: row => row?.employeeUnionLocal?.name,
        sortable: true,
        columnStyles: { 'max-width': '110px', 'white-space': 'inherit' },
        headerStyles: { 'min-width': '3rem' },
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'isOnJobBoard',
        label: 'Project Manager/s',
        property: row => row?.city,
        sortable: true,
        columnStyles: { 'max-width': '110px', 'text-align': '-webkit-center' },
        headerStyles: { 'min-width': '5rem', 'text-align': 'center' },
        columnClasses: { 'text-truncate': false },
      },
      {
        name: 'currentAssignment',
        label: 'Employee Count',
        property: row => row?.city,
        sortable: true,
        columnStyles: {
          'min-width': '100px',
          'max-width': '8%',
          'white-space': 'inherit',
        },
        headerStyles: { 'min-width': '8rem' },
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'currentAssignment',
        label: 'Date Added',
        property: row => row?.city,
        sortable: true,
        columnStyles: {
          'min-width': '100px',
          'max-width': '8%',
          'white-space': 'inherit',
        },
        headerStyles: { 'min-width': '8rem' },
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'currentAssignment',
        label: 'Status',
        component: 'manage-jobs-status',
        property: row => row?.city,
        sortable: true,
        columnStyles: {
          'min-width': '100px',
          'max-width': '8%',
          'white-space': 'inherit',
        },
        headerStyles: { 'min-width': '8rem' },
        columnClasses: { 'text-truncate': true },
      },
    ],
    rowActions: [],
    data: [],
    pagination: {},
    meta: {},
  };

  loadOptions(key: string): void {
    this.jobPointeSettingsService.read[key]().subscribe(
      res => {
        this.loaderService.hideLoader();
        const settings = res.data.reduce((list, item) => {
          list[item.id] = item.name;
          return list;
        }, {});
        this.modelDetail[key] = settings;
        // establish the list of options for the select elements
        let filter = this.filters.filter(f => f.model === key)[0];
        filter.options = res.data;
      },
      error => {
        console.error(error);
        this.loaderService.hideLoader();
      },
    );
  }

  ngAfterViewInit(): void {
    this.loadSelect2();
  }

  loadSelect2() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2();`;
  }

  filters: Array<any> = [
    {
      label: 'Filter by Foreman',
      type: 'select2',
      propertyName: 'scope[city]',
      default: '',
      value: 'id',
      name: 'city',
      model: 'jobCities',
      options: [],
      loadOptions: () => this.loadOptions('jobCities'),
    },
    {
      label: 'Filter By PM',
      type: 'select2',
      propertyName: 'scope[owner]',
      default: '',
      value: 'id',
      name: 'owner_name',
      model: 'owner',
      options: [],
      loadOptions: () => this.loadOptions('owner'),
    },
    {
      label: 'Filter by Status',
      type: 'date-range',
      propertyName: 'scope[dateWorked]',
      default: '',
      value: 'id',
      name: 'label',
      model: 'dateWorked',
      options: [],
    },
    {
      label: 'Filter by Employee',
      type: 'select2',
      propertyName: 'scope[projectManager]',
      default: '',
      value: 'id',
      name: 'employeeAlias',
      model: 'projectManagers',
      options: [],
      loadOptions: () => this.loadOptions('projectManagers'),
    },
  ];
}
